import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Routes , RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { AboutComponent } from './about/about.component';
import { ResumeComponent } from './resume/resume.component';
import { ShowcaseComponent } from './showcase/showcase.component';
import { ContactComponent } from './contact/contact.component';
import { ExtraComponent } from './extra/extra.component';
import { BlogComponent } from './blog/blog.component';
import { HomeComponent } from './home/home.component';

import { TypingAnimationDirective } from 'angular-typing-animation';
import { ComingSoonComponent } from './coming-soon/coming-soon.component'

// const routes:Routes=[
//   {path:'header',component:HeaderComponent},
//   {path:'footer',component:FooterComponent},
//   {path:'resume',component:ResumeComponent},
//   {path:'about',component:AboutComponent},
//   {path:'showcase',component:ShowcaseComponent},
//   {path:'contact',component:ContactComponent}
// ]

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    AboutComponent,
    ResumeComponent,
    ShowcaseComponent,
    ContactComponent,
    ExtraComponent,
    BlogComponent,
    HomeComponent,
    TypingAnimationDirective,
    ComingSoonComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule
    //RouterModule.forRoot(routes)
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
